(() => {
  if (window.pfHeaderSearchReady) return;
  window.pfHeaderSearchReady = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pf-search-open]');
    const dialog = document.getElementById('pf-header-search-dialog');
    if (!dialog) return;
    if (trigger && typeof dialog.showModal === 'function') {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
      dialog.querySelector('input')?.focus();
    } else if (event.target.closest('[data-pf-search-close]')) {
      dialog.close();
    } else if (event.target === dialog) {
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    }
  });
})();